import React, { useEffect, useState } from 'react';
import xtend from 'xtend';
import { useLocation } from 'react-router-dom'
import AssetUpload from 'aws-client';

import { EventEmitter as EE } from 'events';

import * as Sentry from '@sentry/react'

import { QueryClient, QueryClientProvider } from 'react-query'

import config from './config';
import Socket from './utils/SocketAdapter';
import Router from './routes/router.js';
import Api from './utils/ApiAdapter';
import hasRoutePermission from './routes/permissions'

// require('aws-client/lib/aws-sdk-browser');

// we are using a script tag in the html to import aws
AWS.config.update(config.aws);

import Workspace from './common/components/WorkspaceWrapper';
import MessageActions from './common/flux/MessageActions';
import MessageStore from './common/flux/stores/MessageStore';
import InprogressUploads from './inProgressUploads'
import SystemAlerts from './SystemAlerts';
import Loader from './common/components/notifications/Loader';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://2287b3cebb5d4521989bf2ec8d3a3879@o151280.ingest.sentry.io/1201559',
        release: process.env.APP_VERSION,
        normalizeDepth: 10,
    });
}

const queryClient = new QueryClient()

const Setup = props => {
    const { properties, socket } = props
    let route = props.route
    // Supress nanobus timing output
    window.localStorage.DISABLE_NANOTIMING = true;
    if (!route.startsWith('/')) {
        route = '/' + route
    }
    var user = properties.user;
    var client = properties.client;

    if (process.env.NODE_ENV === 'production') {
        Sentry.configureScope(function(scope) {
            scope.setUser({
                id: user.userId,
                email: user.email,
                username: `${user.firstName} ${user.lastName}`,
                client: client.clientID,
                route: route
            })
        });
    }

    var credentials = {
        clientID: client.clientID,
        userID: user.userId,
        email: user.email,
        user: user,
        client: client
    };

    var api = window.api = Api(xtend(config.apiAuthentication, {
        clientID: credentials.clientID,
        crudUrl: config.uris.crud,
        publicUrl: config.uris.public,
        chatUrl: config.chat.rest
    }));
    api.getUppy = properties.getUppy

    // s3 uploads
    var assetUpload = AssetUpload(new AWS.S3({
        // 10 mins timeout
        httpOptions: { timeout: 10 * (60 * 1000) }
    }), credentials.clientID);

    var routerOptions = {
        api: api,
        socket: socket,
        credentials: credentials,
        token: properties.token ?
            JSON.parse(properties.token) :
            null,
        facebookAppID: properties.facebookAppID
    };
    var router = Router(routerOptions);

    var match = router.match(route);
    // var match
    const getMatchingRoute = theRoute => {
        let matchedRoute
        router.routes.forEach(possibleRoute => {
            if (possibleRoute.src === theRoute) {
                matchedRoute = possibleRoute
            }
        })
        return matchedRoute
    }
    match = getMatchingRoute(route)

    let hasPermission = true
    if (route !== "/") {
        // ex route: "/analytics"
        // check the user permissions for analytics.read
        hasPermission = hasRoutePermission(route.split('/').splice(1))
    }
    if (!hasPermission) {
        match = getMatchingRoute('/unauthorized')
        route = "/unauthorized"
    }
    if (match === undefined) {
        // route not found return 404 route
        match = getMatchingRoute('/pageNotFound')
    }
    var routeParams = {...match, path:route}
    // xtend(match, {
    //     path: route
    // });
    // var view = () => match.fn(routeParams);
    var view = match.fn(routeParams)

    class Emitter extends EE {
        emit(type, ...args) {
            super.emit('*', ...args)
            return super.emit(type, ...args) || super.setMaxListeners('', ...args)
        }
    }

    var msgBus = new Emitter();
    msgBus.on('*', data => {
        //messages action
        //console.log('messages action:', data)
    })
    msgBus.emitAction = msgBus.emit.bind(msgBus, 'action');

    var workspaceProps = {
        api: api,
        socket: socket,
        route: {
            path: route,
            params: match.params
        },
        View: view,
        credentials: credentials,
        user: credentials.user,
        actions: {
            messages: MessageActions(api.message, msgBus),
            assetUpload: assetUpload,
            View: view
        },
        stores: {
            messages: MessageStore(msgBus)
        }
    };
    return (
        <div>
            <QueryClientProvider client={queryClient}>
                <SystemAlerts />
                <Workspace {...workspaceProps}/>
                <InprogressUploads getUppy={properties.getUppy}/>
            </QueryClientProvider>
        </div>
    )
}

const App = props => {
    const [socket, setSocket] = useState(null)
    
    // things that should only happen once
    useEffect(() => {
        //on one render setup sockets
        const socketErrorBus = new EE();
        const { drone, socket } = Socket(props.client.clientID,
            socketErrorBus, props.user.userId);
        // this is here just so we can use it in the events list route
        socket.drone = drone;
        setSocket(socket)
    }, [])
    let location = useLocation()
    if (socket) {
        return <Setup route={location.pathname} properties={props} socket={socket} />
    }
    return <Loader/>
}

export default App